import { StringField } from '@components/Fields/StringField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IForm } from '@hooks/useForm';
import { IUsuario } from '@model/Usuario';
import { isString } from '@utils/Functions';
import React from 'react';

export type UsuarioRegistrarFormProps = {
    form: IForm<Partial<IUsuario>>
}

export function UsuarioRegistrarForm ({ form }: UsuarioRegistrarFormProps) {
    const { fields } = form;

    React.useEffect(() => {
        const nome = fields.nome.value;
        let nomeUsuario = "";
        
        if (isString(nome)) {
            const p = nome.split(' ');

            if (p.length > 1) {
                const firstName = p.shift();
                const lastName = p.pop();

                nomeUsuario = `${firstName}.${lastName}`.toLocaleLowerCase();
            }
        }

        fields.nomeUsuario.setValue(nomeUsuario);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fields.nome])

    return (
        <HorizontalGrid spacing={1}>
            <GridItem xs={4}>
                <StringField 
                    field={fields.nome}
                    label="Nome"
                    updateFieldStateOnChange
                />
            </GridItem>

            <GridItem xs={4}>
                <StringField 
                    field={fields.nomeUsuario}
                    label="Nome de Usuário"
                />
            </GridItem>

            <GridItem xs={3}>
                <StringField 
                    field={fields.senha}
                    label="Senha"
                    helperText="Mínimo 6 caracteres"
                />
            </GridItem>
        </HorizontalGrid>
    )
}